<template>
  <div>
    <VDialog
      v-model="mutationToast.isDisplayed"
      class="my-dialog"
      transform-origin=" top left"
      persistent
      scrim="false"
      width="390px"
    >
      <VCard rounded>
        <VToolbar height="35px" dark :color="toast.status">
          <VBtn variant="text">
            <VIcon v-if="toast.status === TOAST_STATUS.SUCCESS" size="30">mdi-check-circle</VIcon>
            <VIcon v-if="toast.status === TOAST_STATUS.WARNING" size="30">mdi-alert</VIcon>
            <VIcon v-if="toast.status === TOAST_STATUS.ERROR" size="30"> mdi-alert-circle </VIcon>
          </VBtn>

          <div class="toast-title">{{ toast.title }}</div>
          <VSpacer></VSpacer>
          <VToolbarItems>
            <VBtn icon @click="hideToast">
              <VIcon size="30">mdi-close-circle-outline</VIcon>
            </VBtn>
          </VToolbarItems>
        </VToolbar>

        <div class="toast-message">
          <span>{{ toast.message }}</span>
          <VSpacer></VSpacer>
        </div>
      </VCard>
    </VDialog>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { type Toast, TOAST_STATUS } from '@/types/toastTypes.ts';

interface Props {
  toast: Toast;
}

const props = defineProps<Props>();

const emit = defineEmits(['hide-toast']);

const mutationToast = ref(props.toast);

function hideToast() {
  mutationToast.value.isDisplayed = false;
  emit('hide-toast', props.toast.id);
}
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.my-dialog .vts-dialog__content {
  position: relative;
  border-radius: 20px;
  padding: 20px;
  font-family: sans-serif;
  top: 0;
  left: 0;
  background: colors.$white;
  transition: 0.3s ease transform;
}

:deep(.v-toolbar__content) {
  padding: 0;

  .v-btn.v-btn--icon.v-size--default,
  .v-toolbar__extension .v-btn.v-btn--icon.v-size--default {
    padding: 0;
    margin-right: 15px;
    width: 0;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    padding: 0;
    min-width: 0;
    margin-left: 5px;
  }

  .v-toolbar__extension {
    padding: 0;
  }
}

.toast-title {
  margin-left: 10px;
  font-weight: bold;
  font-size: 1.1em;
  font-family: sans-serif, Arial;
}

.toast-message {
  padding: 15px 15px 20px 15px;
  text-align: center;
  font-family: sans-serif, Arial;
  background: colors.$very-light-gray;
}

.v-dialog__content {
  font-size: small;
}

@media (min-width: 900px) {
  :deep(.v-dialog) {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
  }
}
</style>
